<div #search class="icon-input-container" (click)="onToggleExpand(true, $event)">
  <bringoz-icon iconName="search-outline" class="input-icon left gray-102"></bringoz-icon>
  <bringoz-icon *ngIf="isExpanded" iconName="close" (click)="onToggleExpand(false, $event)"
                class="close-icon pointer gray-102"></bringoz-icon>
  <input type="text"
         class="form-control input"
         #searchInput
         [placeholder]="placeholder | translate"
         [disabled]="isDisabled">
</div>
